import { AppointmentTypeDto } from "core/gateways/practice/location.dtos";
import { isAvailableOnline } from "core/gateways/practice/location.utils";
import { ProviderAppointmentTypeDto } from "core/gateways/practice/provider.dtos";
import { AppointmentTypeTGDto } from "core/gateways/tenant/tenant.dtos";
import {
  AppointmentTypeCombined,
  BookingStatus,
  ProviderAppointmentTypeCombined
} from "modules/booking/types";

export const checkLocationMultiAppt = (
  appointmentType: AppointmentTypeCombined
) => {
  return (
    (appointmentType.durationTG !== appointmentType.newPatientDuration! ||
      appointmentType.durationTG !== appointmentType.minuteDuration! * 60) &&
    appointmentType.groupBooking &&
    appointmentType.isAvailableNewPatients
  );
};

export function getCombinedAppointmentTypeData(
  appointmentTypes: AppointmentTypeDto[],
  appointmentTypesTG: AppointmentTypeTGDto[]
) {
  if (!appointmentTypes) return null;
  if (!appointmentTypesTG) return null;

  const mergedAppointtmentTypeData = appointmentTypes.map(
    currentAppointmentType => {
      const currentAppointmentTypeTG = appointmentTypesTG.find(
        type => type.id === currentAppointmentType.id
      );

      return {
        maxGroupSize: currentAppointmentTypeTG?.maxGroupSize,
        groupBooking: currentAppointmentTypeTG?.groupBooking,
        durationTG: currentAppointmentTypeTG?.duration,
        bookingStatus: isAvailableOnline(currentAppointmentType)
          ? BookingStatus.Online
          : BookingStatus.Offline,
        premId: currentAppointmentTypeTG?.premId,
        ...currentAppointmentType
      } as AppointmentTypeCombined;
    }
  );
  return mergedAppointtmentTypeData;
}

export function getCombinedProviderAppointmentTypeData(
  providerAppointmentTypes: ProviderAppointmentTypeDto[],
  appointmentTypesTG: AppointmentTypeTGDto[]
) {
  if (!providerAppointmentTypes) return null;
  if (!appointmentTypesTG) return null;

  const mergedAppointtmentTypeData = providerAppointmentTypes.map(
    currentAppointmentType => {
      const currentProviderAppointmentType = appointmentTypesTG.find(
        type => type.id === currentAppointmentType.appointmentTypeId
      );

      return {
        maxGroupSize: currentProviderAppointmentType?.maxGroupSize,
        groupBooking: currentProviderAppointmentType?.groupBooking,
        durationTG: currentProviderAppointmentType?.duration,
        ...currentAppointmentType
      } as ProviderAppointmentTypeCombined;
    }
  );
  return mergedAppointtmentTypeData;
}
